<script setup lang="ts">
import { DisclosurePanel } from "@headlessui/vue";
</script>

<template>
  <DisclosurePanel class="le-faq-panel" role="region">
    <slot />
  </DisclosurePanel>
</template>

<style scoped lang="less">
@import "@dsk/styles/all";

.le-faq-panel {
  padding: 10px 16px;
  border-radius: 0 0 4px 4px;
  background-color: @colors[@accent][100];
  white-space: pre-line;
  .body-text("m");

  #media-breakpoint-up(md, {
    padding: 16px 96px 16px 40px;
  });
}
</style>
